/**
 * @generated SignedSource<<b10fe83a46df0c3750f8372fc8dd3b36>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */
'use strict';

var node = function () {
  var v0 = {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "invoiceId"
  },
      v1 = {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "netTerms"
  },
      v2 = {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "relationshipId"
  },
      v3 = [{
    "alias": null,
    "args": [{
      "kind": "Variable",
      "name": "invoiceId",
      "variableName": "invoiceId"
    }, {
      "kind": "Variable",
      "name": "netTerms",
      "variableName": "netTerms"
    }, {
      "kind": "Variable",
      "name": "relationshipId",
      "variableName": "relationshipId"
    }],
    "concreteType": "invoice",
    "kind": "LinkedField",
    "name": "requestPaymentExtension",
    "plural": false,
    "selections": [{
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    }, {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    }, {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "netTerms",
      "storageKey": null
    }, {
      "alias": null,
      "args": null,
      "concreteType": "datestamp",
      "kind": "LinkedField",
      "name": "dueDate",
      "plural": false,
      "selections": [{
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "year",
        "storageKey": null
      }, {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "month",
        "storageKey": null
      }, {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "day",
        "storageKey": null
      }],
      "storageKey": null
    }],
    "storageKey": null
  }];
  return {
    "fragment": {
      "argumentDefinitions": [v0
      /*: any*/
      , v1
      /*: any*/
      , v2
      /*: any*/
      ],
      "kind": "Fragment",
      "metadata": null,
      "name": "requestPaymentExtensionMutation",
      "selections": v3
      /*: any*/
      ,
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": [v2
      /*: any*/
      , v0
      /*: any*/
      , v1
      /*: any*/
      ],
      "kind": "Operation",
      "name": "requestPaymentExtensionMutation",
      "selections": v3
      /*: any*/

    },
    "params": {
      "cacheID": "7248c02042d6a2aec81e12bdab5b3848",
      "id": null,
      "metadata": {},
      "name": "requestPaymentExtensionMutation",
      "operationKind": "mutation",
      "text": "mutation requestPaymentExtensionMutation(\n  $relationshipId: String!\n  $invoiceId: String!\n  $netTerms: netTermsInput!\n) {\n  requestPaymentExtension(relationshipId: $relationshipId, invoiceId: $invoiceId, netTerms: $netTerms) {\n    id\n    status\n    netTerms\n    dueDate {\n      year\n      month\n      day\n    }\n  }\n}\n"
    }
  };
}();

node.hash = "1944ff509daa844c835033da1ab3f956";
module.exports = node;